/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconRefresh.vue?vue&type=template&id=716f357c"
import script from "./IconRefresh.vue?vue&type=script&lang=js"
export * from "./IconRefresh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('716f357c')) {
      api.createRecord('716f357c', component.options)
    } else {
      api.reload('716f357c', component.options)
    }
    module.hot.accept("./IconRefresh.vue?vue&type=template&id=716f357c", function () {
      api.rerender('716f357c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconRefresh.vue"
export default component.exports